"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  NUMBER: 'NUMBER',
  SHORT_TEXT: 'SHORT_TEXT',
  BOOLEAN: 'BOOLEAN',
  LONG: 'LONG',
  RELATION: 'RELATION',
  RATE: 'RATE'
};
var T;

(function (T) {
  T["NUMBER"] = "NUMBER";
  T["SHORT_TEXT"] = "SHORT_TEXT";
  T["BOOLEAN"] = "BOOLEAN";
  T["LONG"] = "LONG";
  T["RELATION"] = "RELATION";
  T["RATE"] = "RATE";
})(T = exports.T || (exports.T = {}));